export async function getTenkiLink(citycode) {
  const { data: cityData } = await useFetch(`/api/tenki/cityname?citycode=${citycode}`)
  return {
    text: cityData.value ? cityData.value.name : '',
    url: `/cs/cpsite.html?url=https://dcsgtk.wni.co.jp/s/pinpoint/pinpoint.html?city=${citycode}`
  }
}
